var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  background: url(" + escape(require("../../../assets/img/bg-13.jpg")) + ") 50% 50% no-repeat;\n  background-size: cover;\n  display: table-cell;\n  height: 100%;\n  padding: 1.46666667rem 0;\n  vertical-align: middle;\n  width: 100%; }\n  :host card {\n    margin: 0 auto;\n    max-width: 400px; }\n    :host card /deep/ .card-wrap {\n      border: 0; }\n    :host card form button {\n      width: 100%; }\n    :host card form .additional-info {\n      background: rgba(0, 0, 0, 0.1);\n      margin: 1.46666667rem -1.46666667rem -1.46666667rem;\n      padding: 0.73333333rem 1.46666667rem; }\n      :host card form .additional-info .divider {\n        border-left: 1px solid rgba(0, 0, 0, 0.2);\n        display: inline-block;\n        height: 18px;\n        margin: 0 10px;\n        vertical-align: bottom; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/sign-in/sign-in.scss
// module id = ../../../../../src/app/pages/sign-in/sign-in.scss
// module chunks = 39